import script from "./SignupThirdStepForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupThirdStepForm.vue?vue&type=script&setup=true&lang=js"

import "./SignupThirdStepForm.vue?vue&type=style&index=0&id=1ac84b3a&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snedson-auth-backend/snedson-auth-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ac84b3a"]])

export default __exports__